<template>
  <tr class="bg-gray-50 hover:bg-gray-100 transition-colors duration-150 ease-in-out text-right child:py-4 first-child:pl-16 last-child:pr-3 text-sm">
    <td
      class="py-3 text-left"
      :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.variationOrderCode') + ': ' + $props.variationOrder.CodeRef + ', ' + $t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.variationOrderDescription') + ': ' + $props.variationOrder.description"
    >
      <div
        class="flex items-start space-x-2"
        :style="{ paddingLeft: `${(depth * 16)}px` }"
      >
        <span class="max-w-20 font-semibold text-gray-900 flex-shrink-0">{{ $props.variationOrder.CodeRef }}</span>

        <p class="w-60 text-gray-700">
          {{ $props.variationOrder.description }}
        </p>
      </div>
    </td>

    <td
      class="pr-3"
      :title="showBudgetCommentTooltip ? varianceComment.body : ''"
      :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.budgetAmount') + ': ' + ($props.variationOrder.totalBudget ? australianCurrency($props.variationOrder.totalBudget) : '') + (showBudgetCommentTooltip ? ', ' + varianceComment.body : '')"
    >
      <div class="flex items-center justify-end">
        <button
          v-if="showBudgetCommentButton"
          type="button"
          class="btn-icon btn-icon-default mr-1 shrink-0"
          :aria-label="varianceComment ? $t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.editComment') : $t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.addComment')"
          @click.stop="editBudgetComment"
        >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M8.625 9.75a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 01.778-.332 48.294 48.294 0 005.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"
    />
</svg>
        </button>

        <button
          v-else-if="!!varianceComment?.body"
          type="button"
          class="btn-icon btn-icon-default mr-1 shrink-0"
          @click.stop="showBudgetcomment"
        >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M8.625 9.75a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 01.778-.332 48.294 48.294 0 005.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"
    />
</svg>
        </button>

        <div class="min-w-0">
          <VariationOrderLinkedBudget :variation-order="$props.variationOrder" />
        </div>
      </div>
    </td>

    <td class="bg-green-100/50">
      <span v-if="showSubcontractSummary">{{ $tcc(subcontractSummaryClaim) }}</span>
    </td>

    <template v-if="claim.capture_claim_amount">
      <td
        v-if="!falsey(variationOrderCost?.current_claim) && !typingClaim && canEditClaim"
        :class="{ 'cursor-pointer': canEditClaim }"
        class="bg-green-100/50"
        :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.currentClaim') + ': ' + (variationOrderCost.current_claim ? australianCurrency(variationOrderCost.current_claim) : '')"
        @click="typeClaim"
      >
        <div class="group flex items-center justify-end">
          <button
            type="button"
            class="btn-icon group-hover:visible btn-icon-red inline-block invisible"
            :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.removeClaim')"
          >
            <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4"
              @click.stop.capture="removeClaim">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>
          </button>

          <button
            v-if="canEditClaim"
            type="button"
            class="btn-icon group-hover:visible btn-icon-blue inline-block invisible"
            :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.editClaim')"
          >
            <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
          </button>
          {{ !falsey(variationOrderCost.current_claim) ? australianCurrency(variationOrderCost.current_claim) : '' }}
        </div>
      </td>

      <td
        v-else-if="canEditClaim"
        class="bg-green-100/50"
        :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.currentClaim') + ': ' + $t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.editClaim')"
      >
        <div class="w-1/2 ml-auto flex items-center gap-1">
          <div class="ml-auto">
            <AppCurrencyInput
              ref="certifiedInput"
              v-model.number="costForm.form.current_claim"
              name="current_claim"
              type="number"
              min="1"
              class="w-20 h-6 form-input"
              @blur="stopTypingClaim"
              @keyup.enter="stopTypingClaim"
              @keyup.esc="typingClaim = false"
            />
          </div>

          <button
            v-if="subcontractSummaryClaim !== 0"
            class="btn-icon btn-icon-green"
            type="button"
            @click="stopTypingClaim"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
  <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
</svg>
          </button>
        </div>
      </td>

      <td
        v-else
        class="bg-green-100/50"
        :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.currentClaim') + ': ' + (variationOrderCost?.current_claim ? australianCurrency(variationOrderCost.current_claim) : '')"
      >
        {{ !falsey(variationOrderCost?.current_claim) ? $tcc(variationOrderCost.current_claim) : '' }}
      </td>
    </template>

    <td class="bg-green-100/50">
      <span v-if="showSubcontractSummary">{{ $tcc(subcontractSummaryCertified) }}</span>
    </td>

    <td
      v-if="!falsey(variationOrderCost?.current_certified) && !typingCertified && canEditCertified"
      :class="{ 'cursor-pointer': canEditCertified }"
      class="bg-green-100/50"
      :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.currentCertified') + ': ' + (variationOrderCost.current_certified ? australianCurrency(variationOrderCost.current_certified) : '')"
      @click="typeCertified"
    >
      <div class="group flex items-center justify-end">
        <button
          type="button"
          class="btn-icon group-hover:visible btn-icon-red inline-block invisible"
          :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.removeCertified')"
        >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4"
            @click.stop.capture="removeCertified">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>
        </button>

        <button
          v-if="canEditCertified"
          type="button"
          class="btn-icon group-hover:visible btn-icon-blue inline-block invisible"
          :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.editCertified')"
        >
          <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
        </button>
        {{ !falsey(variationOrderCost.current_certified) ? australianCurrency(variationOrderCost.current_certified) : '' }}
      </div>
    </td>

    <td
      v-else-if="canEditCertified"
      class="bg-green-100/50"
      :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.currentCertified') + ': ' + $t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.editCertified')"
    >
      <div class="w-1/2 ml-auto flex items-center gap-1">
        <div class="ml-auto">
          <AppCurrencyInput
            ref="certifiedInput"
            v-model.number="costForm.form.current_certified"
            name="current_certified"
            type="number"
            min="1"
            class="w-20 h-6 form-input"
            @blur="stopTypingCertified"
            @keyup.enter="$event.target.blur()"
            @keyup.esc="typingCertified = false"
          />
        </div>

        <button
          v-if="subcontractSummaryCertified !== 0"
          class="btn-icon btn-icon-green"
          type="button"
          @click="stopTypingCertified"
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
  <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
</svg>
        </button>
      </div>
    </td>

    <td
      v-else
      class="bg-green-100/50"
      :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.currentCertified') + ': ' + (variationOrderCost?.current_certified ? australianCurrency(variationOrderCost.current_certified) : '')"
    >
      {{ variationOrderCost?.current_certified ? australianCurrency(variationOrderCost.current_certified) : '' }}
    </td>

    <td
      v-if="claim.capture_claim_amount"
      class="group bg-green-100/50"
      :class="{ 'text-red-600': hasVariance && variance !== 0 }"
      :title="hasVariance && variance !== 0 && varianceComment?.body ? varianceComment.body : ''"
      :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.varianceAmount') + ': ' + (hasVariance ? australianCurrency(variance) : '') + (hasVariance && variance !== 0 && varianceComment?.body ? ', ' + $t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.varianceTooltip') + ': ' + varianceComment.body : '')"
    >
      <div class="flex items-center justify-end">
        <button
          v-if="showCommentButton"
          type="button"
          class="btn-icon group-hover:visible btn-icon-default invisible mr-1 shrink-0"
          aria-label="Edit variance comment"
          @click.stop="editVarianceComment"
        >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M8.625 9.75a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 01.778-.332 48.294 48.294 0 005.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"
    />
</svg>
        </button>

        <div class="min-w-0">
          {{ hasVariance ? australianCurrency(variance) : '' }}
        </div>
      </div>
    </td>

    <td
      class="bg-green-100/50"
      :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.previousAmount') + ': ' + australianCurrency(variationOrder.previous(claim))"
    >
      {{ australianCurrency(variationOrder.previous(claim)) }}
    </td>

    <td
      class="bg-green-100/50 pr-3"
      :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.cumulativeAmount') + ': ' + australianCurrency(variationOrder.previous(claim) + (variationOrderCost?.current_certified || 0))"
    >
      {{ australianCurrency(variationOrder.previous(claim) + (variationOrderCost?.current_certified || 0)) }}
    </td>

    <template v-if="claim.capture_claim_amount">
      <td
        v-if="showPercentages && !falsey(variationOrderCost?.current_claim) && !typingClaim && canEditClaim && variationOrder.totalBudget"
        :class="{ 'cursor-pointer': canEditClaim }"
        class="bg-blue-100/50"
        :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.claimPercentage') + ': ' + (variationOrderCost?.current_claim ? `${$tn((variationOrderCost.current_claim / variationOrder.totalBudget) * 100)}%` : '')"
        @click="typeClaimPercent"
      >
        <div class="group flex items-center justify-end">
          <button
            type="button"
            class="btn-icon group-hover:visible btn-icon-red inline-block invisible"
            :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.removeClaim')"
          >
            <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4"
              @click.stop.capture="removeClaim">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>
          </button>

          <button
            v-if="canEditClaim"
            type="button"
            class="btn-icon group-hover:visible btn-icon-blue inline-block invisible"
            :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.editClaim')"
          >
            <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
          </button>
          {{ !falsey(variationOrderCost?.current_claim) ? $tp(Math.abs(variationOrderCost.current_claim / variationOrder.totalBudget) * 100) : '' }}
        </div>
      </td>

      <td
        v-else-if="showPercentages && canEditClaim && variationOrder.totalBudget"
        class="bg-blue-100/50"
        :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.claimPercentage') + ': ' + $t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.editClaim')"
      >
        <div class="">
          <AppInput
            ref="claimPercentInput"
            v-model.number="currentClaimPercent"
            name="current_claim_percent"
            type="number"
            class="w-20 h-6 ml-auto form-input"
            @blur="stopTypingClaim"
            @keyup.enter="$event.target.blur()"
            @keyup.esc="typingClaim = false"
          />
        </div>
      </td>

      <td
        v-else-if="showPercentages"
        class="bg-blue-100/50"
        :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.claimPercentage') + ': ' + (variationOrderCost?.current_claim && variationOrder.totalBudget ? `${$tn((variationOrderCost.current_claim / variationOrder.totalBudget) * 100)}%` : '')"
      >
        {{ !falsey(variationOrderCost?.current_claim) && variationOrder.totalBudget ? $tp(Math.abs(variationOrderCost.current_claim / variationOrder.totalBudget) * 100) : '' }}
      </td>

      <td
        v-else
        class="bg-blue-100/50"
      />
    </template>

    <td
      v-if="showPercentages && !falsey(variationOrderCost?.current_certified) && !typingCertified && canEditCertified && variationOrder.totalBudget"
      :class="{ 'cursor-pointer': canEditCertified }"
      class="bg-blue-100/50"
      :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.certifiedPercentage') + ': ' + (variationOrderCost?.current_certified && variationOrder.totalBudget ? `${$tn((variationOrderCost.current_certified / variationOrder.totalBudget) * 100)}%` : '')"
      @click="typeCertifiedPercent"
    >
      <div class="group flex items-center justify-end">
        <button
          type="button"
          class="btn-icon group-hover:visible btn-icon-red inline-block invisible"
          :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.removeCertified')"
        >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4"
            @click.stop.capture="removeCertified">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>
        </button>

        <button
          v-if="canEditCertified"
          type="button"
          class="btn-icon group-hover:visible btn-icon-blue inline-block invisible"
          :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.editCertified')"
        >
          <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
        </button>
        {{ !falsey(variationOrderCost?.current_certified) && variationOrder.totalBudget ? $tp(Math.abs(variationOrderCost.current_certified / variationOrder.totalBudget) * 100) : '' }}
      </div>
    </td>

    <td
      v-else-if="showPercentages && canEditCertified && variationOrder.totalBudget"
      class="bg-blue-100/50"
      :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.certifiedPercentage') + ': ' + $t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.editCertified')"
    >
      <div class="">
        <AppInput
          ref="certifiedPercentInput"
          v-model.number="currentCertifiedPercent"
          name="current_certified_percent"
          type="number"
          class="w-20 h-6 ml-auto form-input"
          @blur="stopTypingCertified"
          @keyup.enter="$event.target.blur()"
          @keyup.esc="typingCertified = false"
        />
      </div>
    </td>

    <td
      v-else-if="showPercentages"
      class="bg-blue-100/50"
      :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.certifiedPercentage') + ': ' + (variationOrderCost?.current_certified && variationOrder.totalBudget ? `${$tn((variationOrderCost.current_certified / variationOrder.totalBudget) * 100)}%` : '')"
    >
      {{ !falsey(variationOrderCost?.current_certified) && variationOrder.totalBudget ? $tp(Math.abs(variationOrderCost.current_certified / variationOrder.totalBudget) * 100) : '' }}
    </td>

    <td
      v-else-if="!claim.capture_claim_amount"
      class="bg-blue-100/50"
    />

    <td
      v-if="showPercentages"
      class="bg-blue-100/50"
      :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.previousPercentage') + ': ' + ($props.variationOrder.totalBudget ? $tp((previousAmount / variationOrder.totalBudget) * 100) : '')"
    >
      {{ $props.variationOrder.totalBudget ? $tp(Math.abs(previousAmount / variationOrder.totalBudget) * 100) : '' }}
    </td>

    <td
      v-if="showPercentages"
      class="bg-blue-100/50 pr-3"
      :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.cumulativePercentage') + ': ' + ($props.variationOrder.totalBudget ? $tp(((previousAmount + (variationOrderCost?.current_certified || 0)) / variationOrder.totalBudget) * 100) : '')"
    >
      {{ $props.variationOrder.totalBudget ? $tp(Math.abs(((previousAmount + (variationOrderCost?.current_certified || 0)) / variationOrder.totalBudget) * 100)) : '' }}
    </td>

    <td
      class="pr-3"
      :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.remainingBudget') + ': ' + ($props.variationOrder.totalBudget ? australianCurrency(variationOrder.totalBudget - variationOrder.previous(claim) - (variationOrderCost?.current_certified || 0)) : '')"
    >
      {{ $props.variationOrder.totalBudget ? australianCurrency(variationOrder.totalBudget - variationOrder.previous(claim) - (variationOrderCost?.current_certified || 0)) : '' }}
    </td>
  </tr>
</template>

<script setup lang="ts">
import VariationOrderLinkedBudget from '@/components/shared/VariationOrderLinkedBudget.vue';
import { useFormData } from '@/composables/useFormData';
import { useStoreApiAction } from '@/composables/useStoreApiAction';
import { australianCurrency, australianNumber, falsey, isNumber, roundDecimals } from '@/helpers';
import { t } from '@/i18n';
import Claim, { ClaimStatus } from '@/models/Claim';
import VariationOrder, { VariationOrderStatus } from '@/models/VariationOrder';
import { useVariationOrderCostsStore } from '@/store/variationOrderCosts';
import Swal from 'sweetalert2';
import { computed, nextTick, ref, watch } from 'vue';
import { toast } from 'vue3-toastify';

const props = withDefaults(
  defineProps<{
    variationOrder: VariationOrder;
    claim: Claim;
    showPercentages?: boolean;
    showSubcontractSummary?: boolean;
    variationOrderCostIdsForClaimPeriod: Id[];
    depth?: number;
  }>(),
  {
    depth: 0,
  },
);

const variationOrderCostsStore = useVariationOrderCostsStore();

const variationOrderCost = computed(() => {
  return variationOrderCostsStore.models.with('comments')
    .where('claim_id', props.claim.id)
    .where(
      'variation_order_id',
      props.variationOrder.id,
    ).first();
});

const canEditCertified = computed(() => {
  return props.claim.status === ClaimStatus.draft &&
    props.variationOrder.status !== VariationOrderStatus.completed &&
    !props.variationOrder.isTransferred;
});

const typingCertified = ref(falsey(variationOrderCost.value?.current_certified));
const certifiedInput = ref();
const certifiedPercentInput = ref();

const typeCertified = () => {
  if(canEditCertified.value) {
    typingCertified.value = true;

    if(variationOrderCost.value) {
      costForm.form.current_certified = variationOrderCost.value.current_certified;
    }

    nextTick(() => {
      certifiedInput.value?.focusInput();
    });
  }
};

const typeCertifiedPercent = () => {
  if(canEditCertified.value) {
    typingCertified.value = true;

    if(variationOrderCost.value) {
      costForm.form.current_certified = variationOrderCost.value.current_certified;
    }

    nextTick(() => {
      certifiedPercentInput.value?.focusInput();
    });
  }
};

const previousAmount = computed(() => {
  return props.variationOrder.previous(props.claim);
});

const currentCertifiedPercent = computed({
  get() {
    return roundDecimals((costForm.form.current_certified / props.variationOrder.totalBudget) * 100) || undefined;
  },

  set(value) {
    if(value + roundDecimals(previousAmount.value / props.variationOrder.totalBudget * 100) === 100) {
      costForm.form.current_certified = props.variationOrder.totalBudget - previousAmount.value;

      return;
    }

    costForm.form.current_certified = roundDecimals((value / 100) * props.variationOrder.totalBudget);
  },
});

const canEditClaim = computed(() => {
  return props.claim.status === ClaimStatus.draft &&
    props.variationOrder.status !== VariationOrderStatus.completed &&
    !props.variationOrder.isTransferred;
});

const typingClaim = ref(falsey(variationOrderCost.value?.current_claim));
const claimInput = ref();
const claimPercentInput = ref();

const typeClaim = () => {
  if(canEditClaim.value) {
    typingClaim.value = true;

    if(variationOrderCost.value) {
      costForm.form.current_claim = variationOrderCost.value.current_claim;
    }

    nextTick(() => {
      claimInput.value?.focusInput();
    });
  }
};

const typeClaimPercent = () => {
  if(canEditClaim.value) {
    typingClaim.value = true;

    if(variationOrderCost.value) {
      costForm.form.current_claim = variationOrderCost.value.current_claim;
    }

    nextTick(() => {
      claimPercentInput.value?.focusInput();
    });
  }
};

const currentClaimPercent = computed({
  get() {
    return roundDecimals((costForm.form.current_claim / props.variationOrder.totalBudget) * 100) || undefined;
  },

  set(value) {
    if(value + roundDecimals(previousAmount.value / props.variationOrder.totalBudget * 100) === 100) {
      costForm.form.current_claim = props.variationOrder.totalBudget - previousAmount.value;

      return;
    }

    costForm.form.current_claim = roundDecimals((value / 100) * props.variationOrder.totalBudget);
  },
});

const costForm = useFormData({
  current_certified: undefined,
  current_claim: undefined,
  comment: undefined,
});

const subcontractSummaryClaim = computed(() => {
  return props.variationOrder.subcontractSummaryClaim(
    props.variationOrderCostIdsForClaimPeriod,
  );
});

const subcontractSummaryCertified = computed(() => {
  return props.variationOrder.subcontractSummaryCertified(
    props.variationOrderCostIdsForClaimPeriod,
  );
});

watch([variationOrderCost, subcontractSummaryClaim, subcontractSummaryCertified], ([newValue]) => {
  if(newValue) {
    costForm.setData(newValue);
  }

  // Prefill from subcontract summary when there is no saved cost yet.
  // Avoid overwriting the user's in-progress edits.
  if(
    (falsey(costForm.form.current_claim) || costForm.form.current_claim === 0) &&
    subcontractSummaryClaim.value !== 0
  ) {
    costForm.form.current_claim = subcontractSummaryClaim.value;
  }

  if(
    (falsey(costForm.form.current_certified) || costForm.form.current_certified === 0) &&
    subcontractSummaryCertified.value !== 0
  ) {
    costForm.form.current_certified = subcontractSummaryCertified.value;
  }
}, { immediate: true });

const storeVariationOrderCostAction = useStoreApiAction(variationOrderCostsStore.createVariationOrderCost);
const updateVariationOrderCostAction = useStoreApiAction(variationOrderCostsStore.updateVariationOrderCost);
const updateCommentAction = useStoreApiAction(variationOrderCostsStore.updateComment);
const deleteCommentAction = useStoreApiAction(variationOrderCostsStore.deleteComment);
const deleteVariationOrderCostAction = useStoreApiAction(variationOrderCostsStore.deleteVariationOrderCost);

const stopTypingClaim = async () => {
  if(
    (falsey(costForm.form.current_claim) && !variationOrderCost.value) ||
    !typingClaim.value
  ) {
    return;
  }

  if(
    variationOrderCost.value &&
    falsey(costForm.form.current_claim) &&
    falsey(variationOrderCost.value.current_certified)
  ) {
    deleteVariationOrderCostAction.request(variationOrderCost.value.id).then(() => {
      typingClaim.value = true;
    }).catch((_error) => {
      Swal.fire({
        icon: 'error',
        title: t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.error.somethingWentWrong'),
      });

      typingClaim.value = false;
    });
  } else if(variationOrderCost.value) {
    costForm.resetData(['comment']);

    if(
      !falsey(variationOrderCost.value.current_certified) &&
      costForm.form.current_claim !== costForm.form.current_certified
    ) {
      // const comment = !tradeComment ?
      const comment = await Swal.fire({
        icon: 'warning',
        title: t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.dialog.reasonForAdjustment'),
        text: t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.dialog.varianceReasonText'),
        input: 'textarea',
        inputValue: varianceComment.value?.body ?? '',
      });
      // :
      // undefined;

      costForm.form.comment = comment?.value;

      // TODO: 10/27/23 maybe stop prompting to apply to trade

      // if(!tradeComment) {
      //   await Swal.fire({
      //     icon: 'question',
      //     title: 'Apply Comment to Trade?',
      //     showConfirmButton: true,
      //     confirmButtonText: 'Yes',
      //     showDenyButton: true,
      //   }).then((result) => {
      //     if(result.isConfirmed) {
      //       costForm.form.comment_trade_item = true;
      //     }
      //   });
      // }
    }

    updateVariationOrderCostAction.request(variationOrderCost.value.id, {
      current_claim: costForm.form.current_claim,
      comment: costForm.form.comment,
    })
      .then((_variationOrderCost) => {
        if(falsey(variationOrderCost.value.current_claim)) {
          typingClaim.value = true;
        } else {
          typingClaim.value = false;
        }
      }).catch((error) => {
        if(error.status === 422) {
          Swal.fire({
            icon: 'error',
            title: t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.error.invalidData'),
            text: error.data.message,
          });
        }

        if(variationOrderCost.value.current_claim === 0) {
          costForm.form.current_claim = subcontractSummaryClaim.value;
        } else {
          costForm.form.current_claim = variationOrderCost.value.current_claim;
        }

        typingClaim.value = false;
      });
  } else {
    storeVariationOrderCostAction.request(props.claim.id, props.variationOrder.id, costForm.only(['current_claim']))
      .then(
        (variationOrderCost) => {
          typingClaim.value = false;
        },
      ).catch((_error) => {
        typingClaim.value = true;
      });
  }
};

const stopTypingCertified = async () => {
  if(
    (falsey(costForm.form.current_certified) && !variationOrderCost.value) ||
    !typingCertified.value
  ) {
    return;
  }

  if(
    falsey(costForm.form.current_certified) && variationOrderCost.value &&
    falsey(variationOrderCost.value.current_claim)
  ) {
    deleteVariationOrderCostAction.request(variationOrderCost.value.id).then(() => {
      typingCertified.value = true;
    }).catch((_error) => {
      typingCertified.value = false;
    });
  } else if(variationOrderCost.value) {
    costForm.resetData(['comment']);

    if(
      !falsey(variationOrderCost.value.current_claim) &&
      costForm.form.current_certified !== variationOrderCost.value.current_claim
    ) {
      // const comment = !tradeComment ?
      const comment = await Swal.fire({
        icon: 'warning',
        title: t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.dialog.reasonForAdjustment'),
        text: t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.dialog.varianceReasonText'),
        input: 'textarea',
        inputValue: varianceComment.value?.body ?? '',
      });
      // :
      // undefined;

      costForm.form.comment = comment?.value;

      // TODO: 10/27/23 maybe stop prompting to apply to trade

      // if(!tradeComment) {
      //   await Swal.fire({
      //     icon: 'question',
      //     title: 'Apply Comment to Trade?',
      //     showConfirmButton: true,
      //     confirmButtonText: 'Yes',
      //     showDenyButton: true,
      //   }).then((result) => {
      //     if(result.isConfirmed) {
      //       costForm.form.comment_trade_item = true;
      //     }
      //   });
      // }
    }

    updateVariationOrderCostAction.request(variationOrderCost.value.id, {
      current_certified: costForm.form.current_certified,
      comment: costForm.form.comment,
    }).then((_variationOrderCost) => {
      if(falsey(variationOrderCost.value?.current_certified)) {
        typingCertified.value = true;
      } else {
        typingCertified.value = false;
      }
    }).catch((error) => {
      if(error.status === 422) {
        Swal.fire({
          icon: 'error',
          title: t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.error.invalidData'),
          text: error.data.message,
        });
      }

      if(variationOrderCost.value.current_certified === 0) {
        costForm.form.current_certified = subcontractSummaryCertified.value;
      } else {
        costForm.form.current_certified = variationOrderCost.value.current_certified;
      }

      typingCertified.value = false;
    });
  } else {
    storeVariationOrderCostAction.request(props.claim.id, props.variationOrder.id, costForm.only(['current_certified']))
      .then(
        (variationOrderCost) => {
          typingCertified.value = false;
        },
      ).catch((error) => {
        if(error.status === 422) {
          Swal.fire({
            icon: 'error',
            title: t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.error.invalidAmount'),
            text: error.data.message,
          });
        }

        typingCertified.value = true;
      });
  }
};

const deleteCost = () => {
  deleteVariationOrderCostAction.request(variationOrderCost.value.id).then(() => {
    if(subcontractSummaryCertified.value !== 0) {
      costForm.form.current_certified = subcontractSummaryCertified.value;
    } else {
      costForm.form.current_certified = undefined;
    }

    if(subcontractSummaryClaim.value !== 0) {
      costForm.form.current_claim = subcontractSummaryClaim.value;
    } else {
      costForm.form.current_claim = undefined;
    }

    typingCertified.value = true;
    typingClaim.value = true;
  });
};

const removeClaim = () => {
  if(falsey(variationOrderCost.value.current_certified)) {
    deleteCost();
  } else {
    updateVariationOrderCostAction.request(variationOrderCost.value.id, { current_claim: undefined })
      .then((_tradeItemCost) => {
        typingClaim.value = true;

        if(subcontractSummaryClaim.value !== 0) {
          costForm.form.current_claim = subcontractSummaryClaim.value;
        }
      }).catch((error) => {
        if(error.status === 422) {
          Swal.fire({
            icon: 'error',
            title: t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.error.invalidAmount'),
            text: error.data.message,
          });
        }

        costForm.form.current_claim = variationOrderCost.value.current_claim;
      });
  }
};

const removeCertified = () => {
  if(falsey(variationOrderCost.value.current_claim)) {
    deleteCost();
  } else {
    updateVariationOrderCostAction.request(variationOrderCost.value.id, { current_certified: undefined })
      .then((_tradeItemCost) => {
        typingCertified.value = true;

        if(subcontractSummaryCertified.value !== 0) {
          costForm.form.current_certified = subcontractSummaryCertified.value;
        }
      }).catch((error) => {
        if(error.status === 422) {
          Swal.fire({
            icon: 'error',
            title: t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.error.invalidAmount'),
            text: error.data.message,
          });
        }

        costForm.form.current_certified = variationOrderCost.value.current_certified;
      });
  }
};

const varianceComment = computed(() => {
  return variationOrderCost.value?.comments[0];
});

const variance = computed(() => {
  return variationOrderCost.value?.current_claim - variationOrderCost.value?.current_certified;
});

const hasVariance = computed(() => {
  return !falsey(variationOrderCost.value?.current_claim) && !falsey(variationOrderCost.value?.current_certified);
});

const showCommentButton = computed(() => {
  return hasVariance.value && variance.value !== 0 && !!varianceComment.value && canEditCertified.value;
});

const isOptionalComment = computed(() => {
  if(!variationOrderCost.value) {
    return false;
  }

  const claim = variationOrderCost.value.current_claim;
  const certified = variationOrderCost.value.current_certified;

  if(falsey(claim) || falsey(certified)) {
    return false;
  }

  return claim === certified;
});

const showBudgetCommentButton = computed(() => {
  return canEditCertified.value && !falsey(variationOrderCost.value) &&
    !falsey(variationOrderCost.value.current_certified) &&
    (props.claim.capture_claim_amount ? !falsey(variationOrderCost.value.current_claim) : true);
});

const showBudgetCommentTooltip = computed(() => {
  return !!varianceComment.value?.body && showBudgetCommentButton.value;
});

const showBudgetcomment = () => {
  Swal.fire({
    icon: 'info',
    title: (hasVariance.value && variance.value !== 0) ? 'Reason for Adjustment' : 'Comment',
    text: varianceComment.value?.body,
  });
};

const editBudgetComment = () => {
  Swal.fire({
    icon: 'info',
    title: (hasVariance.value && variance.value !== 0) ? 'Reason for Adjustment' : 'Comment',
    text: (hasVariance.value && variance.value !== 0) ?
      'Please provide a reason for the variance between the claim and certified amounts.' :
      'Provide an optional comment for the cost.',

    input: 'textarea',
    inputValue: varianceComment.value?.body ?? '',
    showCancelButton: true,
    confirmButtonText: varianceComment.value ? 'Update' : 'Save',
    showDenyButton: isOptionalComment.value && !!varianceComment.value,
    denyButtonText: 'Delete',
    denyButtonColor: '#d33',
  }).then((result) => {
    if(result.isDenied && varianceComment.value) {
      deleteCommentAction.request(variationOrderCost.value.id, varianceComment.value.id).then(() => {
        toast.success('Comment deleted');
      });
    } else if(result.isConfirmed && result.value) {
      if(varianceComment.value) {
        updateCommentAction.request(variationOrderCost.value.id, varianceComment.value.id, { comment: result.value })
          .then(() => {
            toast.success('Comment updated');
          });
      } else {
        updateVariationOrderCostAction.request(variationOrderCost.value.id, { comment: result.value })
          .then(() => {
            toast.success('Comment saved');
          });
      }
    }
  });
};

const editVarianceComment = () => {
  Swal.fire({
    icon: 'warning',
    title: t('ClaimCertifiedCosts.TradeRowItem.alert.reasonAdjustmentTitle'),
    text: t('ClaimCertifiedCosts.TradeRowItem.alert.reasonAdjustmentText'),
    input: 'textarea',
    inputValue: varianceComment.value?.body ?? '',
    showCancelButton: true,
    confirmButtonText: 'Update',
  }).then((result) => {
    if(result.isConfirmed) {
      if(result.value) {
        updateCommentAction.request(variationOrderCost.value.id, varianceComment.value.id, { comment: result.value })
          .then(() => {
            toast.success('Comment updated');
          });
      }
    }
  });
};
</script>

<style scoped></style>
